// @flow

export const DEFAULT_SUGGESTION_BLOCK = [
  {
    type: 'suggestions',
    label: 'AdminHTML.InstantSearchDisplay.Constant.defaultSuggestionBlock1_Label',
    status: 'active',
    number: 5
  },
  {
    type: 'collections',
    label: 'AdminHTML.InstantSearchDisplay.Constant.defaultSuggestionBlock2_Label',
    status: 'active',
    number: 3
  },
  {
    type: 'products',
    label: 'AdminHTML.InstantSearchDisplay.Constant.defaultSuggestionBlock3_Label',
    status: 'active',
    number: 6
  },
  {
    type: 'pages',
    label: 'AdminHTML.InstantSearchDisplay.Constant.defaultSuggestionBlock4_Label',
    status: 'active',
    number: 3
  }
];

export const NUMBER_SEARCH_TERM_SUGGESTIONS = 10;

export const NUMBER_PRODUCT_SUGGESTIONS = 10;

export const NUMBER_PRODUCT_SUGGESTIONS_PER_PAGE = 20;

export const DEFAULT_LAYOUT_SETTINGS = {
  suggestionStyle: 'style2',
  suggestionStyle1ProductItemType: 'list',
  suggestionStyle1ProductPosition: 'none',
  suggestionStyle1ProductPerRow: '1',
  suggestionStyle2ProductItemType: 'list',
  suggestionStyle2ProductPosition: 'right',
  suggestionStyle2ProductPerRow: '2',
  suggestionStyle3ProductItemType: 'list',
  suggestionStyle3ProductPosition: 'right',
  suggestionStyle3ProductPerRow: '3'
};

export const LAYOUT_SUGGESTION_STYLE_LABEL = {
  style1: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionStyle1_Label',
  style2: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionStyle2_Label',
  style3: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionStyle3_Label'
};

export const LAYOUT_SUGGESTION_PRODUCT_ITEM_TYPE = [
  {
    value: 'grid',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductItemType_Label1'
  },
  {
    value: 'list',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductItemType_Label2'
  }
];

export const LAYOUT_SUGGESTION_PRODUCT_POSITION = [
  {
    value: 'left',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductPosition_Label1'
  },
  {
    value: 'right',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductPosition_Label2'
  }
];

export const LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE2 = [
  {
    value: '1',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductsPerRow_Label1'
  },
  {
    value: '2',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductsPerRow_Label2'
  }
];

export const LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE3 = [
  {
    value: '2',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductsPerRow_Label2'
  },

  {
    value: '3',
    label: 'AdminHTML.InstantSearchDisplay.Constant.layoutSuggestionProductsPerRow_Label3'
  }
];

export const SEARCH_TERM_LIST = [
  {
    value: 'based_on_data',
    label: 'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.searchTerm_RadioButton1_Label',
    tooltip:
      'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.searchTerm_RadioButton1_Tooltip'
  },
  {
    value: 'manually',
    label: 'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.searchTerm_RadioButton2_Label'
  }
];

export const PRODUCT_LIST = [
  {
    value: 'based_on_data',
    label:
      'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.popularProduct_RadioButton1_Label',
    tooltip:
      'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.popularProduct_RadioButton1_Tooltip'
  },
  {
    value: 'manually',
    label:
      'AdminHTML.InstantSearchDisplay.NoSearchResultSuggestions.popularProduct_RadioButton2_Label'
  }
];
